import { action } from "mobx";
import Immersive3dTourFloorPlanImportRepository from "~/repository/Immersive3dTour/Immersive3dTourFloorPlanImportRepository";
import NestStore from "~/stores/NestStore";

class Immersive3dTourFloorPlanImportStore extends NestStore {
  tourId = null;

  immersive3dTourFloorPlanImportRepository = null;

  constructor() {
    super();

    this.immersive3dTourFloorPlanImportRepository = new Immersive3dTourFloorPlanImportRepository();
  }

  @action
  update(images) {
    this.isLoading = true;

    return this.immersive3dTourFloorPlanImportRepository
      .update(this.tourId, { images })
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

export default Immersive3dTourFloorPlanImportStore;
